import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

export const initI18Next = (env: string) =>
    i18n
        .use(Backend)
        .use(LanguageDetector)
        .use(initReactI18next) // bind react-i18next to the instance
        .init({
            fallbackLng: 'en',
            debug: true,
            ns: ['translation'],
            defaultNS: '',
            interpolation: {
                escapeValue: false // not needed for react!!
            },
            backend: {
                //https://cdn.freedommortgage.com/content/test/locales/en-US/marketing.dev.json
                loadPath: `https://cdn.freedommortgage.com/content/${env}/locales/en-US/{{ns}}.${env}.json`
            }
        });
